import _uniqBy from "lodash/uniqBy";
import _orderBy from "lodash/orderBy";

const StatesAndProvinces = {
    mergeProtectoratesAndUsaGroups: function() {
        let countries = _.filter(this.get(), i => (
            i.group == "USA" || i.group == "Canada" || i.group == "Mexico"
        ));

        let protectorates = _.filter(this.get(), { group: "Protectorates" })
                .map(value => value.states)[0];

        return _.filter(countries, country => {
            if (country.group === "USA") {
                let states = country.states;
                let merged = states.concat(protectorates);

                country.states = _.orderBy(merged, ["state"], ["asc"]);
            }

            return country;
        });
    },

    getStatesOnSelectedCountry: function(country) {
        let statesAndProvinces = this.mergeProtectoratesAndUsaGroups();

        return _.filter(statesAndProvinces, { group: country })
                .map(value => value.states)[0];
    },

    getState: function(val) {
        let state = null,
            statesAndProvinces = this.mergeProtectoratesAndUsaGroups();

        _.forEach(statesAndProvinces, value => {
            let states = _.filter(value.states, { stateCode: val })[0];

            if ( states ) {
                states.group = value.group;
                state = states;
                return false;
            }
        });

        return state;
    },

    getSupportedCountries: function() {
        return _.filter(this.mergeProtectoratesAndUsaGroups(), i => (
            i.group == "USA" || i.group == "Canada" || i.group == "Mexico"
        ));
    },

    getTimezone: function (stateCode, country) {
        let selectedState = _.filter(this.getTimezonePerCountry(country), item => {
            return item.stateCode === stateCode;
        });      

        if (selectedState.length > 0) {
            return selectedState[0]["value"];
        } else {
            return "";
        }
    },

    getTimezonePerCountry: function (country) {
        const list = _.filter(this.mergeProtectoratesAndUsaGroups(), { group: country }),
            listOfTimeZonePerCountry =  _.map(list[0]["states"], item => {
                return {
                    name: item.timezoneName,
                    value: item.timezoneCode,
                    stateCode: item.stateCode
                };
            });

        return listOfTimeZonePerCountry;

    },

    getListOfTimezonePerCountry: function (country) {
        return _orderBy(_uniqBy(this.getTimezonePerCountry(country), "name"), "name");
    },

    get: function(){
        return [
            {
                group: "USA",
                states: [
                    {
                        state: "Alabama",
                        stateCode: "AL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Alaska",
                        stateCode: "AK",
                        timezoneCode: "US/Alaska",
                        timezoneName: "US/Alaska"
                    },
                    {
                        state: "Arkansas",
                        stateCode: "AR",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Arizona",
                        stateCode: "AZ",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "California",
                        stateCode: "CA",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "Colorado",
                        stateCode: "CO",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "Connecticut",
                        stateCode: "CT",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "District of Columbia",
                        stateCode: "DC",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Delaware",
                        stateCode: "DE",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Florida",
                        stateCode: "FL",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Georgia",
                        stateCode: "GA",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Hawaii",
                        stateCode: "HI",
                        timezoneCode: "Pacific/Honolulu",
                        timezoneName: "HST"
                    },
                    {
                        state: "Idaho",
                        stateCode: "ID",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Illinois",
                        stateCode: "IL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Indiana",
                        stateCode: "IN",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Iowa",
                        stateCode: "IA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Kansas",
                        stateCode: "KS",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Kentucky",
                        stateCode: "KY",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Louisiana",
                        stateCode: "LA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Maine",
                        stateCode: "ME",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Maryland",
                        stateCode: "MD",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Massachusetts",
                        stateCode: "MA",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Michigan",
                        stateCode: "MI",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Minnesota",
                        stateCode: "MN",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Mississippi",
                        stateCode: "MS",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Missouri",
                        stateCode: "MO",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Montana",
                        stateCode: "MT",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Nebraska",
                        stateCode: "NE",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Nevada",
                        stateCode: "NV",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"                        
                    },
                    {
                        state: "New Hampshire",
                        stateCode: "NH",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "New Jersey",
                        stateCode: "NJ",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "New Mexico",
                        stateCode: "NM",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "New York",
                        stateCode: "NY",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "North Carolina",
                        stateCode: "NC",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "North Dakota",
                        stateCode: "ND",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Ohio",
                        stateCode: "OH",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Oklahoma",
                        stateCode: "OK",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Oregon",
                        stateCode: "OR",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "Pennsylvania",
                        stateCode: "PA",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Rhode Island",
                        stateCode: "RI",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "South Carolina",
                        stateCode: "SC",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "South Dakota",
                        stateCode: "SD",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Tennessee",
                        stateCode: "TN",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Texas",
                        stateCode: "TX",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Utah",
                        stateCode: "UT",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Vermont",
                        stateCode: "VT",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Virginia",
                        stateCode: "VA",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Washington",
                        stateCode: "WA",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "West Virginia",
                        stateCode: "WV",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Wisconsin",
                        stateCode: "WI",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Wyoming",
                        stateCode: "WY",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    }
                ]
            },
            {
                group: "Protectorates",
                states: [
                    {
                        state: "American Samoa",
                        stateCode: "AS",
                        timezoneCode: "UTC",
                        timezoneName: "UTC"
                    },
                    {
                        state: "Guam",
                        stateCode: "GU",
                        timezoneCode: "UTC",
                        timezoneName: "UTC"
                    },
                    {
                        state: "Northern Marianas",
                        stateCode: "MP",
                        timezoneCode: "UTC",
                        timezoneName: "UTC"
                    },
                    {
                        state: "Puerto Rico",
                        stateCode: "PR",
                        timezoneCode: "UTC",
                        timezoneName: "UTC"
                    },
                    {
                        state: "Virgin Islands",
                        stateCode: "VI",
                        timezoneCode: "UTC",
                        timezoneName: "UTC"
                    }
                ]
            },
            {
                group: "Canada",
                states: [
                    {
                        state: "Alberta",
                        stateCode: "AB",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "British Columbia",
                        stateCode: "BC",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Manitoba",
                        stateCode: "MB",
                        timezoneCode: "Canada/Atlantic",
                        timezoneName: "Canada/Atlantic"
                    },
                    {
                        state: "New Brunswick",
                        stateCode: "NB",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Newfoundland and Labrador",
                        stateCode: "NL",
                        timezoneCode: "America/St_Johns",
                        timezoneName: "CNT"
                    },
                    {
                        state: "Nova Scotia",
                        stateCode: "NS",
                        timezoneCode: "America/Halifax",
                        timezoneName: "America/Halifax"
                    },
                    {
                        state: "Northwest Territories",
                        stateCode: "NT",
                        timezoneCode: "America/Yellowknife",
                        timezoneName: "AmeriName/Yellowknife"
                    },
                    {
                        state: "Ontario",
                        stateCode: "ON",
                        timezoneCode: "America/Toronto",
                        timezoneName: "America/Toronto"
                    },
                    {
                        state: "Prince Edward Island",
                        stateCode: "PE",
                        timezoneCode: "America/Halifax",
                        timezoneName: "America/Halifax"
                    },
                    {
                        state: "Quebec",
                        stateCode: "QC",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Saskatchewan",
                        stateCode: "SK",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Yukon Territory",
                        stateCode: "YT",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    }
                ]
            },
            {
                group: "Mexico",
                states: [
                    {
                        state: "Aguascalientes",
                        stateCode: "MEX_AG",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Baja California Norte",
                        stateCode: "MEX_BN",
                        timezoneCode: "PST8PDT",
                        timezoneName: "Pacific (PST8PDT)"
                    },
                    {
                        state: "Baja California Sur",
                        stateCode: "MEX_BS",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Coahuila",
                        stateCode: "MEX_CH",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Chihuahua",
                        stateCode: "MEX_CI",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Colima",
                        stateCode: "MEX_CL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Campeche",
                        stateCode: "MEX_CP",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Chiapas",
                        stateCode: "MEX_CS",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "District of Federal",
                        stateCode: "MEX_DF",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Durango",
                        stateCode: "MEX_DG",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Guerrero",
                        stateCode: "MEX_GE",
                        timezoneCode: "CST6CDT",
                        timezoneCName: "Central (CST6CDT)"
                    },
                    {
                        state: "Guanajuato",
                        stateCode: "MEX_GJ",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Hidalgo",
                        stateCode: "MEX_HD",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Jalisco",
                        stateCode: "MEX_JA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Michoacan",
                        stateCode: "MEX_MC",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Morelos",
                        stateCode: "MEX_MR",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Mexico",
                        stateCode: "MEX_MX",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Nayarit",
                        stateCode: "MEX_NA",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Nuevo Leon",
                        stateCode: "MEX_NL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Oaxaca",
                        stateCode: "MEX_OA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Puebla",
                        stateCode: "MEX_PU",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Queretaro",
                        stateCode: "MEX_QE",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Quinatana",
                        stateCode: "MEX_QI",
                        timezoneCode: "EST5EDT",
                        timezoneName: "Eastern (EST5EDT)"
                    },
                    {
                        state: "Sinalao",
                        stateCode: "MEX_SI",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "San Luis Potosi",
                        stateCode: "MEX_SL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Sonora",
                        stateCode: "MEX_SO",
                        timezoneCode: "MST7MDT",
                        timezoneName: "Mountain (MST7MDT)"
                    },
                    {
                        state: "Tamaulipas",
                        stateCode: "MEX_TA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Tabasco",
                        stateCode: "MEX_TB",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Tlaxcala",
                        stateCode: "MEX_TL",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Veracruz",
                        stateCode: "MEX_VC",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Yucatan",
                        stateCode: "MEX_YU",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    },
                    {
                        state: "Zacatecas",
                        stateCode: "MEX_ZA",
                        timezoneCode: "CST6CDT",
                        timezoneName: "Central (CST6CDT)"
                    }
                ]
            }
        ]
    }
};

export default StatesAndProvinces;
